import React, {useEffect, useState} from "react";

export const Carousel = (props) => {
    const [photos, setPhotos] = useState([]);

    const [imagesReady, setImagesReady] = useState(false);

    useEffect(() => {

        const promises = props.imagesToImport.map(fileName => {
            return import('../images/school-gallery/' + props.sourceDirectory + fileName);
        });

        Promise.allSettled(promises).then((results) => {
            const paths = [];

            results.forEach((result, index) => {
                paths.push(result.value?.default);
            });

            setPhotos(paths);
            setImagesReady(true);
        });
    }, [props.imagesToImport, props.sourceDirectory]);

    return <div>{imagesReady ? (
            <div id="carouselIndicators" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    {photos.map((photo, index) => <li data-target="#carouselIndicators" data-slide-to={index}
                                                      className={index === 0 ? 'active' : ''} key={index}></li>)}
                </ol>
                <div className="carousel-inner">
                    {photos.map((photo, index) => (
                        <div className={index === 0 ? 'carousel-item active' : 'carousel-item'} key={index}>
                            <img className="d-block w-100"
                                 src={photo}
                                 alt="Archeology school in Iran"/>
                        </div>
                    ))}
                </div>
                <a className="carousel-control-prev" href="#carouselIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carouselIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        ) : ''
    }</div>
};
